import Logo from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
    { id: "about", label: "Manufacturer" },
    { id: "products", label: "The Range" },
    { id: "quality", label: "Quality" },
    { id: "contact", label: "Contact" },
];

const CERTS = ["API 6A", "API 6D", "ISO 9001", "ISO 15848-1", "SIL 3", "NACE MR0175"];

export default function Footer() {
    return (
        <footer
            data-testid="main-footer"
            className="border-t border-white/10 bg-obsidian-950"
        >
            <div className="mx-auto max-w-7xl px-6 py-16 sm:px-8">
                <div className="flex flex-col justify-between gap-12 md:flex-row">
                    <div className="max-w-xs">
                        <Logo onClick={() => scrollToId("hero")} />
                        <p className="mt-5 text-sm leading-relaxed text-slate-500">
                            UK manufacturer of API 6A and API 6D valves for
                            the oil &amp; gas industry.
                        </p>
                    </div>
                    <nav className="flex flex-col gap-3">
                        <p className="mb-1 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                            Navigate
                        </p>
                        {LINKS.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`footer-link-${l.id}`}
                                onClick={() => scrollToId(l.id)}
                                className="self-start font-display text-xl font-bold uppercase tracking-wide text-slate-300 transition-colors hover:text-tactical"
                            >
                                {l.label}
                            </button>
                        ))}
                    </nav>
                    <div>
                        <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                            Compliance Scope
                        </p>
                        <div className="flex max-w-xs flex-wrap gap-2">
                            {CERTS.map((c) => (
                                <span
                                    key={c}
                                    className="border border-steel px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-slate-400"
                                >
                                    {c}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="mt-14 flex flex-col justify-between gap-4 border-t border-white/10 pt-8 md:flex-row">
                    <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
                        © {new Date().getFullYear()} Blackhawk Valves Ltd — United Kingdom
                    </p>
                    <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-tactical">
                        API 6A · API 6D Compliant Manufacturing
                    </p>
                </div>
            </div>
        </footer>
    );
}
